import { useGeneralInfo, useOffer } from '../../hooks';
import { Title } from '../../components/Title';

export function TitleContainer() {
  const { title, subtitle } = useGeneralInfo();
  const { href, isTop } = useOffer();

  return <Title isTop={isTop} title={title} subtitle={subtitle} href={href} />;
}
